/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResolveCaseNoteTemplateRequest
 */
export interface ResolveCaseNoteTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof ResolveCaseNoteTemplateRequest
     */
    clientId: string;
    /**
     * 
     * @type {Date}
     * @memberof ResolveCaseNoteTemplateRequest
     */
    appointment?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof ResolveCaseNoteTemplateRequest
     */
    previousAppointment?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof ResolveCaseNoteTemplateRequest
     */
    newAppointment?: Date | null;
}

/**
 * Check if a given object implements the ResolveCaseNoteTemplateRequest interface.
 */
export function instanceOfResolveCaseNoteTemplateRequest(value: object): value is ResolveCaseNoteTemplateRequest {
    if (!('clientId' in value) || value['clientId'] === undefined) return false;
    return true;
}

export function ResolveCaseNoteTemplateRequestFromJSON(json: any): ResolveCaseNoteTemplateRequest {
    return ResolveCaseNoteTemplateRequestFromJSONTyped(json, false);
}

export function ResolveCaseNoteTemplateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResolveCaseNoteTemplateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'clientId': json['clientId'],
        'appointment': json['appointment'] == null ? undefined : (new Date(json['appointment'])),
        'previousAppointment': json['previousAppointment'] == null ? undefined : (new Date(json['previousAppointment'])),
        'newAppointment': json['newAppointment'] == null ? undefined : (new Date(json['newAppointment'])),
    };
}

export function ResolveCaseNoteTemplateRequestToJSON(json: any): ResolveCaseNoteTemplateRequest {
    return ResolveCaseNoteTemplateRequestToJSONTyped(json, false);
}

export function ResolveCaseNoteTemplateRequestToJSONTyped(value?: ResolveCaseNoteTemplateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'clientId': value['clientId'],
        'appointment': value['appointment'] == null ? value['appointment'] : value['appointment'].toISOString(),
        'previousAppointment': value['previousAppointment'] == null ? value['previousAppointment'] : value['previousAppointment'].toISOString(),
        'newAppointment': value['newAppointment'] == null ? value['newAppointment'] : value['newAppointment'].toISOString(),
    };
}

